import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { MdOutlineMoreHoriz } from "react-icons/md";
import {
  SELLER_DARK_MENU_ITEM_SX,
  SELLER_DARK_MENU_PAPER_SX,
} from "../../ui/seller-dark-menu-sx";

/**
 * Row actions (…) menu — dark popup aligned with product table designs.
 */
export function ProductActionsMenu({
  product,
  onViewProduct,
  onStockUp,
  onEditProduct,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const menuId = `product-actions-${product?.id ?? "row"}`;

  const close = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        aria-label="Open actions"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: "#9CA3AF" }}
      >
        <MdOutlineMoreHoriz className="text-[22px]" />
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: SELLER_DARK_MENU_PAPER_SX,
          },
        }}
        MenuListProps={{ dense: true }}
      >
        <MenuItem
          onClick={() => {
            close();
            onViewProduct?.(product);
          }}
          sx={SELLER_DARK_MENU_ITEM_SX}
        >
          View Product
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            onStockUp?.(product);
          }}
          sx={SELLER_DARK_MENU_ITEM_SX}
        >
          Stock Up
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            onEditProduct?.(product);
          }}
          sx={SELLER_DARK_MENU_ITEM_SX}
        >
          Edit Product
        </MenuItem>
      </Menu>
    </>
  );
}
